$(function(){
    var test = localStorage.input === 'true'? true: false;
    $('input').prop('checked', test || false);
 hidePrice();
});

$('input').on('change', function() {
    localStorage.input = $(this).is(':checked');
    console.log($(this).is(':checked'));
  
});
$('input[type=checkbox]').click(function () {
  
   hidePrice();
});

  

function hidePrice() {
    var priceLabel = $('.product-single__price');
    var gridPriceLabel = $('.grid-product__price-wrap');
  var compprice = $('.product-single__price--compare-at');
  
    if ($('#hidePrice').is(':checked')) {
      console.log('checked');
      priceLabel.hide();
      priceLabel.css("display","none")
      gridPriceLabel.hide();
     compprice.hide();
      localStorage.setItem("hidePrice", false);
    } else {
      console.log('un-checked');
      priceLabel.show(); 
      priceLabel.css("display","inline")
      gridPriceLabel.show();
      compprice.show();
      localStorage.setItem("hidePrice", true);
    } 
};
  
$(document).ready(function () {
  console.log('footer ready');
  
  var hidePrice = localStorage.getItem("hidePrice");
  console.log('hidePrice from localStorage:'+ hidePrice);
  $('#hidePrice').prop('', hidePrice);
  //hidePrice();
  
});

    